import classNames from "classnames";
import { uniqueId } from "lodash";
import { Component } from "react";
import { RouteComponentProps } from "react-router";
import { QESButton, QESCheckbox } from "@app/shared/qes-standards";

interface GenerateBodyProps extends RouteComponentProps<unknown> {
  emailOnSuccess: boolean;
  isLoading: boolean;
  onEmailOnSuccessChange: (emailOnSuccess: boolean) => void;
  onGenerateClick: () => Promise<void>;
  onReportNameChange: (reportName: string) => void;
  reportName: string;
}

export default class GenerateBody extends Component<GenerateBodyProps> {
  private readonly reportNameId = uniqueId("outreach-data-control-");

  public render() {
    const isFileNameOk = this.props.reportName && this.props.reportName.length > 0 && this.props.reportName.length < 255;
    const hasError = !isFileNameOk;
    const emailId = uniqueId("email-me");

    return (
      <>
        <hr />
        <div className="row">
          <div className="col-12 col-sm-6">
            <div className={classNames("form-inline align-items-center", { "has-error": hasError })}>
              <label className="mr-1 col-form-label font-weight-bold" htmlFor={this.reportNameId}>Report Name:</label>
              <input
                type="text"
                id={this.reportNameId}
                className="form-control w-25"
                value={this.props.reportName}
                onChange={(e) => this.props.onReportNameChange(e.target.value)}
              />

              {isFileNameOk ? (
                <QESCheckbox
                  containerClassName="form-check ml-2 font-weight-bold form-check-label"
                  label={<><i className="fa fa-envelope mr-2" /> Yes, please email me a link to the report when ready.</>}
                  id={emailId}
                  className="form-check-input mr-2"
                  checked={this.props.emailOnSuccess}
                  onChange={(e) => this.props.onEmailOnSuccessChange(e.target.checked)}
                  testId="generate-outreach-body__email-when-ready"
                />
              ) : (
                <label className="ml-2 text-danger"> Invalid report name, please enter a name between 1 and 255 characters.</label>
              )}
            </div>
            <div className="form-row align-items-center mt-3">
              <div className="col-12">
                {this.props.isLoading ? (
                  <QESButton qesTestId="generate-body_generating" qesType="primary" disabled className="mr-2"><i className="fa fa-spinner fa-spin" /> Generating...</QESButton>
                ) : (
                  <QESButton
                    qesTestId="generate-body_generate"
                    qesType="primary"
                    disabled={!isFileNameOk}
                    className="mr-2"
                    onClick={this.props.onGenerateClick}
                  >Generate</QESButton>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
